import type { TorRuleFormItem, TorRulesFormValues } from "./types";

export const TOR_POLICY_OPTIONS = [
  { label: "Flat", value: "or" as const },
  { label: "Tiered", value: "and" as const },
];

export const DEFAULT_TOR_RULE: TorRuleFormItem = {
  torPercent: 0,
  minSale: 0,
  maxSale: 0,
  uptoLimit: 1,
  minLimit: 0,
};

export const DEFAULT_TOR_RULES_FORM: TorRulesFormValues = {
  torRuleCondition: "or",
  torRules: [DEFAULT_TOR_RULE],
};

export const MAX_TOR_RULES = 5;
